export default __webpack_public_path__ + "static/media/plodeIcon.8923aabc.svg";